import { Trans } from '@lingui/macro'
import {
  Button,
  FormControl,
  FormControlLabel,
  FormGroup,
  Switch,
} from '@material-ui/core'
import { useAutorun } from '@speedlo/hooks'
import { useLocalStore, useObserver } from 'mobx-react-lite'
import React from 'react'
import { GoPay } from 'shopify-payment-core'

import { Brick } from '../../atoms/Brick'
import { useFirebaseFunctions } from '../../hooks/useFirebaseFunctions'
import { useSnackBar } from '../../hooks/useSnackBar'
import { i18n } from '../../i18n'

interface IProps {
  account: GoPay.IAccount
}

export const GoPayInstruments: React.FC<IProps> = ({ account }) => {
  const available = [
    {
      label: i18n.t`Online platba`,
      value: GoPay.EPaymentInstrument.PAYMENT_CARD,
    },
    {
      label: i18n.t`Bankovní převod`,
      value: GoPay.EPaymentInstrument.BANK_ACCOUNT,
    },
  ]

  const { changePaymentInstruments } = useFirebaseFunctions()

  const state = useLocalStore(() => ({
    enabled: new Set((account.enabledPaymentInstruments
      ? account.enabledPaymentInstruments.split(',')
      : [GoPay.EPaymentInstrument.PAYMENT_CARD]) as RoA<
      GoPay.EPaymentInstrument
    >),
    default:
      account.defaultPaymentInstrument || GoPay.EPaymentInstrument.PAYMENT_CARD,
  }))

  useAutorun(() => {
    changePaymentInstruments({
      accountId: account.id,
      segmentKey: account.segmentKey,
      defaultInstrument: state.default,
      // @ts-ignore wrong typing in function args, should be string, not string[]
      enabledInstruments: Array.from(state.enabled.values()).join(','),
    })
  })

  useAutorun(() => {
    if (state.enabled.size === 1 || !state.enabled.has(state.default)) {
      const [first] = Array.from(state.enabled.values())
      state.default = first
    }
  })

  const { enqueueInfo } = useSnackBar()

  return useObserver(() => (
    <Brick title={i18n.t`Povolené platební metody`} admin={true}>
      <FormControl component="fieldset">
        <FormGroup row={true}>
          {available.map(({ label, value }) => (
            <React.Fragment key={value}>
              <FormControlLabel
                control={
                  <Switch
                    checked={state.enabled.has(value)}
                    onChange={() => {
                      if (state.enabled.has(value)) {
                        if (state.enabled.size === 1) {
                          enqueueInfo(
                            i18n.t`Minimálně jedna platební metoda musí být povolena.`,
                          )
                          return
                        }
                        state.enabled.delete(value)
                      } else {
                        state.enabled.add(value)
                      }
                    }}
                    value={value}
                  />
                }
                label={label}
              />
              <Button
                variant="text"
                size="small"
                onClick={() => {
                  state.default = value
                  state.enabled.add(value)
                }}
                disabled={state.default === value}
              >
                {state.default === value ? (
                  <Trans>Je výchozí</Trans>
                ) : (
                  <Trans>Nastav výchozí</Trans>
                )}
              </Button>
            </React.Fragment>
          ))}
        </FormGroup>
      </FormControl>
    </Brick>
  ))
}
